import { cognitoSignOut } from 'utils/signout/cognitoSignOut'

import { useTranslation } from 'react-i18next'
import React from 'react'
import { Button } from '@trussworks/react-uswds'

type SignOutProps = {
  isNavLink: boolean
}

export const SignOut = ({ isNavLink }: SignOutProps) => {
  const { t } = useTranslation('common', { keyPrefix: 'header' })

  const handleOnClickSignOut = (ev: React.SyntheticEvent) => {
    if (isNavLink) ev.preventDefault()
    cognitoSignOut()
  }

  const linkEl = (
    <Button
      onClick={handleOnClickSignOut}
      key="logout"
      type="button"
      unstyled
      className="usa-link usa-nav__link"
    >
      {t('logout')}
    </Button>
  )

  const buttonEl = (
    <Button
      id="signOutButtonCmp"
      accentStyle="warm"
      type="button"
      data-testid="sign-out-button-cmp"
      onClick={handleOnClickSignOut}
    >
      {t('signout')}
    </Button>
  )

  return isNavLink ? linkEl : buttonEl
}
